import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowDown } from "lucide-react";
import SocialRow from "@/components/SocialRow";
import NewsletterSignupModal from "@/components/NewsletterSignupModal";

const PORTRAIT_IMG =
  "https://customer-assets.emergentagent.com/job_metamorph-saga/artifacts/f3ltvl6r_250814_GEORGE_MAPLE_0668.jpg";

export default function Landing() {
  const [newsletterOpen, setNewsletterOpen] = useState(false);
  return (
    <main
      className="relative h-[100svh] w-full overflow-hidden flex items-center justify-center"
      data-testid="landing-page"
    >
      {/* Full-bleed portrait */}
      <img
        src={PORTRAIT_IMG}
        alt="Metamorph — by George Maple"
        className="landing-hero-img"
        aria-hidden
      />
      <div className="landing-hero-wash" aria-hidden />

      {/* Top-right circle enter button */}
      <Link
        to="/manifesto"
        aria-label="Enter"
        className="hero-enter-btn"
        data-testid="cta-enter-circle"
      >
        <ArrowDown className="w-5 h-5" strokeWidth={1.4} />
      </Link>

      {/* Wordmark centered */}
      <div className="relative z-10 flex flex-col items-center text-center px-6 mm-fade-in">
        <h1
          className="deco-text uppercase leading-[0.92] tracking-[0.04em] text-6xl sm:text-8xl md:text-9xl"
          data-testid="hero-title"
        >
          Metamorph
        </h1>
        <p
          className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.4em] opacity-70 mt-3 self-end pr-1 sm:pr-2"
          data-testid="hero-byline"
        >
          by George Maple
        </p>

        <Link
          to="/manifesto"
          className="vintage-link text-[11px] sm:text-xs uppercase inline-flex items-center gap-3 mt-10 sm:mt-14"
          data-testid="cta-enter"
        >
          Click to enter <ArrowDown className="w-3 h-3" strokeWidth={1.2} />
        </Link>
      </div>

      {/* Subtle contact tucked away */}
      <Link
        to="/contact"
        className="vintage-link absolute top-6 left-6 sm:top-8 sm:left-10 z-20 text-[10px] sm:text-xs uppercase"
        data-testid="cta-contact"
      >
        Contact
      </Link>

      {/* Photo credit — subtle, top-right */}
      <a
        href="https://www.instagram.com/stephcammarano/"
        target="_blank"
        rel="noopener noreferrer"
        className="vintage-link absolute top-6 right-6 sm:top-8 sm:right-10 z-20 text-[9px] sm:text-[10px] uppercase opacity-50 hover:opacity-90"
        data-testid="photo-credit"
      >
        Image · Steph Cammarano
      </a>

      {/* Footer — email sign-up + socials, kept very small at the bottom */}
      <footer className="absolute bottom-5 sm:bottom-6 left-0 right-0 z-20 flex flex-col items-center gap-3">
        <button
          type="button"
          onClick={() => setNewsletterOpen(true)}
          className="vintage-link text-[9px] sm:text-[10px] uppercase opacity-55 hover:opacity-100"
          data-testid="cta-subscribe"
        >
          Email sign up
        </button>
        <SocialRow className="opacity-55 [&_a]:text-[9px] [&_a]:sm:text-[10px]" />
      </footer>

      <NewsletterSignupModal open={newsletterOpen} onClose={() => setNewsletterOpen(false)} />
    </main>
  );
}
